<template>
    <div>
        <van-empty description="暂无内容" v-if="!live.content" />
        <div class="live-content" v-else>
            <p v-html="live.content"></p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Content',
    props: {
        live: {
            type: Object,
            required: true
        }
    }
}
</script>

<style lang="less" scoped>
    .live-content {
        background: #fff;
        color: #323233;

        p {
            margin: 0px;
        }
    }
</style>
